import { render, staticRenderFns } from "./DragProfilePhoto.vue?vue&type=template&id=33e687a8&scoped=true"
import script from "./DragProfilePhoto.vue?vue&type=script&lang=js"
export * from "./DragProfilePhoto.vue?vue&type=script&lang=js"
import style0 from "./DragProfilePhoto.vue?vue&type=style&index=0&id=33e687a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e687a8",
  null
  
)

export default component.exports